import { ServiceEstimate } from '../types';

export const servicesDisclaimer =
  'هذه تقديرات وليست أسعاراً ثابتة. التسعير النهائي يعتمد على المتطلبات والتكاملات والتعقيد والجدول الزمني.';

export const serviceEstimates: ServiceEstimate[] = [
  {
    id: 'mobile-simple',
    category: 'Mobile Application',
    projectType: 'تطبيق موبايل بسيط',
    estimatedTime: '4–8 أسابيع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Low',
    typicalFeatures: ['واجهة أساسية', 'مصادقة المستخدم', 'الوظائف الأساسية', 'نشر على المتجر'],
  },
  {
    id: 'mobile-business',
    category: 'Mobile Application',
    projectType: 'تطبيق أعمال',
    estimatedTime: '8–16 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Medium',
    typicalFeatures: ['أدوار المستخدم', 'لوحة تحكم', 'إشعارات', 'تكامل خلفية', 'تحليلات'],
  },
  {
    id: 'mobile-ecommerce',
    category: 'Mobile Application',
    projectType: 'تطبيق تجارة إلكترونية',
    estimatedTime: '12–20 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'High',
    typicalFeatures: ['Catalog منتجات', 'سلة ودفع', 'تكامل دفع', 'إدارة طلبات', 'إشعارات'],
  },
  {
    id: 'mobile-marketplace',
    category: 'Mobile Application',
    projectType: 'تطبيق سوق',
    estimatedTime: '16–28 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Very High',
    typicalFeatures: ['دعم بائعين متعددين', 'توجيه الطلبات', 'تقسيم الدفع', 'لوحات إدارية', 'تتبع لحظي'],
  },
  {
    id: 'mobile-booking',
    category: 'Mobile Application',
    projectType: 'تطبيق حجز',
    estimatedTime: '8–14 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Medium',
    typicalFeatures: ['تكامل التقويم', 'إدارة المواعيد', 'إشعارات', 'اكتشاف الخدمات'],
  },
  {
    id: 'mobile-advanced',
    category: 'Mobile Application',
    projectType: 'تطبيق موبايل متقدم',
    estimatedTime: '20+ أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Very High',
    typicalFeatures: ['بنية معقدة', 'دعم offline', 'طبقة أمان', 'متعدد المنصات', 'تكاملات مخصصة'],
  },
  {
    id: 'web-landing',
    category: 'Web Application',
    projectType: 'صفحة هبوط',
    estimatedTime: '1–3 أسابيع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Low',
    typicalFeatures: ['تصميم متجاوب', 'نموذج تواصل', 'تحسين SEO', 'تحليلات'],
  },
  {
    id: 'web-business',
    category: 'Web Application',
    projectType: 'موقع أعمال',
    estimatedTime: '3–6 أسابيع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Low',
    typicalFeatures: ['موقع متعدد الصفحات', 'تكامل CMS', 'تواصل ونماذج', 'تصميم متجاوب'],
  },
  {
    id: 'web-admin',
    category: 'Web Application',
    projectType: 'لوحة تحكم إدارية',
    estimatedTime: '6–12 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Medium',
    typicalFeatures: ['جداول بيانات', 'رسوم وتحليلات', 'إدارة مستخدمين', 'صلاحيات حسب الدور'],
  },
  {
    id: 'web-saas',
    category: 'Web Application',
    projectType: 'تطبيق SaaS',
    estimatedTime: '12–24 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'High',
    typicalFeatures: ['بنية متعددة المستأجرين', 'فوترة اشتراك', 'لوحة مستخدم', 'تكامل API'],
  },
  {
    id: 'web-ecommerce',
    category: 'Web Application',
    projectType: 'تطبيق تجارة إلكترونية ويب',
    estimatedTime: '10–18 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'High',
    typicalFeatures: ['إدارة منتجات', 'سلة تسوق', 'بوابة دفع', 'تتبع طلبات'],
  },
  {
    id: 'backend-api',
    category: 'Backend',
    projectType: 'REST API',
    estimatedTime: '4–8 أسابيع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Medium',
    typicalFeatures: ['نقاط RESTful', 'مصادقة', 'تصميم قاعدة بيانات', 'توثيق'],
  },
  {
    id: 'backend-auth',
    category: 'Backend',
    projectType: 'نظام مصادقة',
    estimatedTime: '2–4 أسابيع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Medium',
    typicalFeatures: ['JWT/OAuth', 'إدارة أدوار', 'إعادة تعيين كلمة المرور', 'إدارة جلسات'],
  },
  {
    id: 'backend-admin',
    category: 'Backend',
    projectType: 'خلفية إدارية',
    estimatedTime: '6–10 أسابيع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Medium',
    typicalFeatures: ['عمليات CRUD', 'تقارير', 'إدارة مستخدمين', 'سجلات تدقيق'],
  },
  {
    id: 'backend-ecommerce',
    category: 'Backend',
    projectType: 'خلفية تجارة إلكترونية',
    estimatedTime: '10–16 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'High',
    typicalFeatures: ['API Catalog منتجات', 'معالجة طلبات', 'تكامل دفع', 'إدارة مخزون'],
  },
  {
    id: 'backend-multitenant',
    category: 'Backend',
    projectType: 'خلفية متعددة المستأجرين',
    estimatedTime: '12–20 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Very High',
    typicalFeatures: ['عزل المستأجرين', 'بنية تحتية مشتركة', 'إعداد لكل مستأجر', 'بنية قابلة للتوسع'],
  },
  {
    id: 'ai-chatbot',
    category: 'AI',
    projectType: 'روبوت محادثة ذكي',
    estimatedTime: '4–8 أسابيع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Medium',
    typicalFeatures: ['معالجة لغة طبيعية', 'وعي بالسياق', 'واجهات تكامل', 'سجل محادثات'],
  },
  {
    id: 'ai-rag',
    category: 'AI',
    projectType: 'نظام RAG',
    estimatedTime: '6–12 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'High',
    typicalFeatures: ['استيعاب مستندات', 'تخزين متجهات', 'بحث دلالي', 'تكامل LLM'],
  },
  {
    id: 'ai-knowledge',
    category: 'AI',
    projectType: 'مساعد معرفة خاص',
    estimatedTime: '8–14 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'High',
    typicalFeatures: ['فهرسة بيانات خاصة', 'استرجاع آمن', 'صلاحيات حسب الدور', 'استشهاد بالمصادر'],
  },
  {
    id: 'ai-agent',
    category: 'AI',
    projectType: 'وكيل ذكاء اصطناعي',
    estimatedTime: '8–16 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Very High',
    typicalFeatures: ['سير عمل مستقل', 'تكامل أدوات', 'اتخاذ قرارات', 'استدلال متعدد الخطوات'],
  },
  {
    id: 'ai-automation',
    category: 'AI',
    projectType: 'أتمتة أعمال بالذكاء الاصطناعي',
    estimatedTime: '6–12 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'High',
    typicalFeatures: ['أتمتة عمليات', 'معالجة مستندات', 'تكامل سير عمل', 'تقارير'],
  },
  {
    id: 'ai-local',
    category: 'AI',
    projectType: 'نظام ذكاء اصطناعي محلي/خاص',
    estimatedTime: '10–18 أسبوع',
    estimatedCostRange: '[أضف النطاق]',
    complexity: 'Very High',
    typicalFeatures: ['نشر محلي', 'LLM محلي', 'RAG خاص', 'سيادة البيانات'],
  },
];

export const serviceCategories = [
  'Mobile Application',
  'Web Application',
  'Backend',
  'AI',
] as const;
